import { client } from "../dtos/Client";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/from";
import * as Dtos from "../dtos/Tmd.dtos";

export const trialGroupItemCategoryApi = {
    getTrialGroupItemCategoriesByTrialGroupId: (trialGroupId?: number): Observable<Dtos.GetTrialGroupItemCategoriesByTrialGroupIdResponse> => {
        //Create the request.
        let request: Dtos.GetTrialGroupItemCategoriesByTrialGroupId = new Dtos.GetTrialGroupItemCategoriesByTrialGroupId();

        request.trialGroupId = trialGroupId;

        //Send request.
        const response: Promise<Dtos.GetTrialGroupItemCategoriesByTrialGroupIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    }
}